// AnalyticsReportCard.jsx

import React from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { Line } from 'react-chartjs-2';

// ...existing code...
const AnalyticsReportCard = ({
  analytics,
  dateRange,
  setDateRange,
  domain,
  setDomain,
  exportToCSV,
  domains
}) => {
  // Fix: Ensure analytics is always an array
  const safeAnalytics = Array.isArray(analytics) ? analytics : [];
  console.log('Analytics Data:', safeAnalytics);

  // Prepare chart data
  const labels = safeAnalytics.map(item => item.date);
  const chartData = {
    labels,
    datasets: [
      {
        label: 'Applications',
        data: safeAnalytics.map(item => item.total_applications),
        borderColor: '#007bff',
        backgroundColor: 'rgba(0,123,255,0.1)',
        fill: true,
      },
      {
        label: 'Attended',
        data: safeAnalytics.map(item => item.attended_meet_greet),
        borderColor: '#28a745',
        backgroundColor: 'rgba(40,167,69,0.1)',
        fill: true,
      },
      {
        label: 'Registered',
        data: safeAnalytics.map(item => item.registered_startupworld),
        borderColor: '#17a2b8',
        backgroundColor: 'rgba(23,162,184,0.1)',
        fill: true,
      },
      {
        label: 'Assigned',
        data: safeAnalytics.map(item => item.assigned_project),
        borderColor: '#ffc107',
        backgroundColor: 'rgba(255,193,7,0.1)',
        fill: true,
      }
    ]
  };
  // ...existing code...

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: false }
    }
  };

  const handleStartDateChange = (date) => {
    setDateRange({ ...dateRange, start_date: date });
  };

  const handleEndDateChange = (date) => {
    setDateRange({ ...dateRange, end_date: date });
  };

  const handleDomainChange = (e) => {
    setDomain(e.target.value === 'All' ? '' : e.target.value);
  };

  const handleExport = () => {
    exportToCSV(analytics, 'analytics_report.csv');
  };

  return (
    <Card className="mb-4">
      <Card.Header>
        <h5>Analytics Report</h5>
      </Card.Header>
      <Card.Body>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Start Date</Form.Label>
              <DatePicker
                selected={dateRange.start_date}
                onChange={handleStartDateChange}
                className="form-control"
                dateFormat="yyyy-MM-dd"
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>End Date</Form.Label>
              <DatePicker
                selected={dateRange.end_date}
                onChange={handleEndDateChange}
                className="form-control"
                dateFormat="yyyy-MM-dd"
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Domain</Form.Label>
              <Form.Select value={domain || 'All'} onChange={handleDomainChange}>
                {domains.map((d) => (
                  <option key={d} value={d}>{d}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={3} className="d-flex align-items-end">
            <Button
              variant="outline-primary"
              onClick={handleExport}
              disabled={!analytics.length}
            >
              Export to CSV
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Line data={chartData} options={chartOptions} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default AnalyticsReportCard;